// import React, { useState } from "react";

// export default function ForgotPasswordPage() {
//   const [email, setEmail] = useState("");
//   const [codeSent, setCodeSent] = useState(false);
//   const [enteredCode, setEnteredCode] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [step, setStep] = useState(1);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleEmailSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     try {
//       const res = await fetch("https://your-api.com/check-user-email", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email }),
//       });
//       const data = await res.json();
//       if (!data.exists) {
//         setError("Email not found.");
//         setLoading(false);
//         return;
//       }
//       // Send email with code
//       await fetch("https://your-api.com/send-reset-code", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email }),
//       });

//       setSuccess("Verification code sent to your email.");
//       setCodeSent(true);
//       setStep(2);
//     } catch (err) {
//       setError("Failed to send reset code.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCodeVerification = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     try {
//       const res = await fetch("https://your-api.com/verify-code", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, code: enteredCode }),
//       });
//       const data = await res.json();

//       if (data.valid) {
//         setStep(3);
//         setSuccess("Code verified. Please reset your password.");
//       } else {
//         setError("Invalid code.");
//       }
//     } catch (err) {
//       setError("Error verifying code.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePasswordReset = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);

//     if (newPassword !== confirmPassword) {
//       setError("Passwords do not match.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const res = await fetch("https://your-api.com/reset-password", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, newPassword }),
//       });
//       const data = await res.json();

//       if (data.success) {
//         setSuccess("Password updated successfully!");
//         setStep(4);
//       } else {
//         setError("Failed to update password.");
//       }
//     } catch (err) {
//       setError("Error resetting password.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ maxWidth: "400px", margin: "50px auto", fontFamily: "Arial" }}>
//       <h2>Forgot Password</h2>
//       {error && <p style={{ color: "red" }}>{error}</p>}
//       {success && <p style={{ color: "green" }}>{success}</p>}

//       {step === 1 && (
//         <form onSubmit={handleEmailSubmit}>
//           <input
//             type="email"
//             placeholder="Enter your email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//             style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
//           />
//           <button disabled={loading} style={{ padding: "10px", width: "100%" }}>
//             {loading ? "Sending..." : "Send Verification Code"}
//           </button>
//         </form>
//       )}

//       {step === 2 && (
//         <form onSubmit={handleCodeVerification}>
//           <input
//             type="text"
//             placeholder="Enter verification code"
//             value={enteredCode}
//             onChange={(e) => setEnteredCode(e.target.value)}
//             required
//             style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
//           />
//           <button disabled={loading} style={{ padding: "10px", width: "100%" }}>
//             {loading ? "Verifying..." : "Verify Code"}
//           </button>
//         </form>
//       )}

//       {step === 3 && (
//         <form onSubmit={handlePasswordReset}>
//           <input
//             type="password"
//             placeholder="New password"
//             value={newPassword}
//             onChange={(e) => setNewPassword(e.target.value)}
//             required
//             style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
//           />
//           <input
//             type="password"
//             placeholder="Confirm new password"
//             value={confirmPassword}
//             onChange={(e) => setConfirmPassword(e.target.value)}
//             required
//             style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
//           />
//           <button disabled={loading} style={{ padding: "10px", width: "100%" }}>
//             {loading ? "Updating..." : "Update Password"}
//           </button>
//         </form>
//       )}

//       {step === 4 && (
//         <div>
//           <p>Password has been successfully updated. You may now log in.</p>
//         </div>
//       )}
//     </div>
//   );
// }








import React, { useState } from "react";
import { useNavigate } from "react-router-dom";


export default function ForgotPassword() {
  const [step, setStep] = useState(1); // 1=email, 2=code, 3=reset, 4=success
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [Code2, setCode2] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");



  const navigate = useNavigate();

  // === STEP 1: Verify Email and Send Code ===
  const handleSendCode = async () => {
    setError("");
    if (!email) return setError("Please enter your email.");

    try {
      // 👇 Replace with your actual API endpoint
      const res = await fetch("https://yovho-back.vercel.app/New-code-send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.Error || "Email not found");
      if (data.Error) throw new Error(data.Error);

      // ✅ Email exists, code sent
      console.log(data)
      setStep(2);
      setCode2(data.Ma)
    } catch (err) {
    console.log(err.message)
      setError(err.message);
    }
  };

  // === STEP 2: Verify the Code ===
  const handleVerifyCode = async () => {
    setError("");
    if (!code) return setError("Please enter the code sent to your email.");

    try {
      // 👇 Replace with your actual code verification API
     if(code == Code2){

         setStep(3);
     }else{
        return setError("Please the correct code which sent to your email.")
     }

      // ✅ Code verified
    } catch (err) {
      setError(err.message);
    }
  };

  // === STEP 3: Set New Password ===
  const handleResetPassword = async () => {
    setError("");
    if (!newPassword || !confirmPassword) return setError("Fill all fields.");
    if (newPassword !== confirmPassword) return setError("Passwords do not match.");
    if (newPassword.length < 8) return setError("Password must be at least 8 characters.");

    try {
      // 👇 Replace with your password reset API
      const res = await fetch("https://yovho-back.vercel.app/logIn-new-pass", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, pass:newPassword }),
      });

      const data = await res.json();

      if (!res.ok) throw new Error("Failed to reset password");

      // ✅ Password successfully changed
      if(!data.Error){
          setStep(4);
          setSuccess("Password updated successfully.");
            setTimeout(()=>{
                    navigate("/login");

            },2000)
      }
      else{
        return setError("Please Reload and Again Reset");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "10px",
    margin: "10px 0",
    borderRadius: "6px",
    border: "1px solid #ccc",
  };

  const buttonStyle = {
    padding: "10px 15px",
    backgroundColor: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    marginTop: "10px",
    width: "100%",
  };

  return (
    <div style={{ maxWidth: 400, margin: "100px auto", padding: "20px", background: "#fff", borderRadius: 8, boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}>
      <h2 style={{ textAlign: "center", marginBottom: 20 }}>Forgot Password</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}

      {step === 1 && (
        <>
          <input
            type="email"
            placeholder="Enter your email"
            style={inputStyle}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button style={buttonStyle} onClick={handleSendCode}>Send Code</button>
        </>
      )}

      {step === 2 && (
        <>
          <input
            type="text"
            placeholder="Enter verification code"
            style={inputStyle}
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <button style={buttonStyle} onClick={handleVerifyCode}>Verify Code</button>
        </>
      )}

      {step === 3 && (
        <>
          <input
            type="password"
            placeholder="New password"
            style={inputStyle}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <input
            type="password"
            placeholder="Confirm password"
            style={inputStyle}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button style={buttonStyle} onClick={handleResetPassword}>Update Password</button>
        </>
      )}

      {step === 4 && (
        <p style={{ textAlign: "center", fontWeight: "bold" }}>{success}</p>
      )}
    </div>
  );
}
